import {
  Component,
  OnInit,
  OnDestroy,
  Renderer2,
  ElementRef,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener,
  AfterViewInit,
} from '@angular/core';
import { Subscription, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { DirectionService } from '../../direction.service';
import { DataSharingService } from '../data-shering-service/data-sharing.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/auth.service';

import { DialogService } from 'src/app/dialog/dialog.service';

import { ClustersService } from './clusters.service';
import { getMapTilerStyleUrl } from 'src/app/maptiler/maptiler-style-url';
import { UsersService } from 'src/app/super-management/user/users.service';
import * as maplibregl from 'maplibre-gl';
import { ChatProductSystemKey } from 'src/app/other-pages/chat/chat.service';

@Component({
  selector: 'app-choose-branch',
  templateUrl: './choose-branch.component.html',
  styleUrls: ['./choose-branch.component.scss'],
  host: {
    class: 'fill-screen',
  },
})
export class ChooseBranchComponent implements OnInit, OnDestroy, AfterViewInit {
  isLoading: boolean = false;
  isRTL: boolean = true;
  isDarkMode: boolean = false;
  private directionSubscription: Subscription;
  public hoveredPrintingService: string = '';
  public clusterName: string = '';
  public clusters: any[] = [];
  public filteredClusters: any[] = [];
  public filteredClustersIndexes: boolean[] = [];
  branchName: string = '';
  continueToClusterText: string = '';
  byPrinterNumberExplanation: string = '';
  userIsAuthenticated = false;
  userId: string;
  private authStatusSub: Subscription;
  isSystemSet: boolean = false;
  private branchSub: Subscription;
  private clusterSub: Subscription;
  isScreenWide: boolean = false;
  isSmUp: boolean = false;
  @ViewChildren('branchElement') branchElements!: QueryList<ElementRef>;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  scrollPosition: number = 0;
  private scrollListener: () => void;

  private map: any;
  isMapMode: boolean = false;
  /** מפתח: '3dprint' | 'phprint' – האם כרטיס ה־PH במצב «מידע נוסף» */
  private phMoreInfoByKind: Record<string, boolean> = {};
  /** שליטה על הצגת מערכות PH בעמוד / (מגיע מה־Backend דרך systemchecks.avalblesystems) */
  avalbleSystems: { '3DPrint': boolean; phPrint: boolean } = { '3DPrint': true, phPrint: true };

  // map
  @ViewChildren('mapBranchItem') mapBranchItems: QueryList<ElementRef>;
  mapContainerWidth: number = 0;
  mapContainerHeight: number = 0;
  public filteredBranches: any[] = [];
  branchesMapLocationsList: any[] = [];
  resizeObserver: any;
  zoom: number = 8;
  private markerElements: HTMLElement[] = [];

  // search
  searchPlaceholder: string = '';
  searchText: string = '';
  private translateSub: Subscription;
  isfilteredClustersEmpty: boolean = false;
  printerTypeFilter: 'all' | 'plotter' | 'express' | 'pics' = 'all';
  sortDirection: 'northToSouth' | 'southToNorth' = 'northToSouth';

  constructor(
    private directionService: DirectionService,
    private dataSharingService: DataSharingService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private clustersService: ClustersService,
    private renderer: Renderer2,
    private usersService: UsersService
  ) {
    this.translateService.onLangChange.subscribe(() => {
      this.updatecontinueToClusterText();
      this.updatebyPrinterNumberExplanation();
    });
    this.setSearchPlaceholder();
  }

  ngOnInit() {
    this.isLoading = true;

    this.route.params.subscribe(params => {
      const branchName = params['branchName'];
      if (branchName) {
        console.log('Branch name from route:', branchName);
        this.handleBranchFromRoute(branchName);
      }
    });

    this.directionService.direction$.subscribe((direction) => {
      this.isRTL = direction === 'rtl';
    });

    this.translateSub = this.translateService.onLangChange.subscribe(() => {
      this.setSearchPlaceholder();
      this.searchText = '';
      this.updateClusterName();
      this.filterClusters();
    });

    this.directionService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode = isDarkMode;
    });

    this.isScreenWide = window.innerWidth > 786;
    this.isSmUp = window.innerWidth >= 576;

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();

    const applyShortLangPath = () => {
      const lang = (this.route.snapshot.data['homeLang'] as string | undefined)?.trim() || null;
      if (lang) {
        this.directionService.toLanguageDirection(lang);
        if (this.userIsAuthenticated) {
          this.usersService.updateUserLanguage(lang);
        }
      }
    };
    applyShortLangPath();
    this.route.data.subscribe(() => applyShortLangPath());

    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((isAuthenticated) => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
        if (!isAuthenticated) {
          this.branchName = '';
          this.clusterName = '';
          this.isSystemSet = false;
        }
      });

    this.branchSub = this.dataSharingService.getBranch().subscribe((value) => {
      this.branchName = value;
      this.updateClusterName();
    });

    this.clusterSub = this.dataSharingService
      .getCluster()
      .subscribe((value) => {
        this.clusterName = value;
      });

    this.clustersService
      .getClustersWithAvailableSystems()
      .pipe(
        retry(3),
        catchError((error) => {
          console.error('Failed to fetch clusters after 3 attempts:', error);
          window.location.href = 'https://print.eazix.io';
          return throwError(error);
        })
      )
      .subscribe(({ clusters, avalblesystems }) => {
        if (avalblesystems && typeof avalblesystems === 'object') {
          this.avalbleSystems = {
            '3DPrint': avalblesystems['3DPrint'] ?? this.avalbleSystems['3DPrint'],
            phPrint: avalblesystems.phPrint ?? this.avalbleSystems.phPrint,
          };
        }
        this.clusters = this.sortClustersByLon(clusters);
        this.filteredClusters = this.clusters;
        this.isLoading = false;
        this.updateClusterName();
        this.updateBranchesMapLocationsList(this.clusters);
      });
  }

  private sortClustersByLon(clusters: any[]): any[] {
    return [...clusters].sort((a, b) => {
      // If cluster doesn't have place or lat, put it at the end
      const aHasPlace = a.place && a.place.lat !== undefined && a.place.lat !== null;
      const bHasPlace = b.place && b.place.lat !== undefined && b.place.lat !== null;
      
      if (!aHasPlace && !bHasPlace) {
        return 0; // Both don't have place/lat - keep original order
      }
      if (!aHasPlace) {
        return 1; // a goes to end
      }
      if (!bHasPlace) {
        return -1; // b goes to end
      }
      
      // Both have place and lat - sort by lat
      const aLat = a.place?.lat ?? -Infinity;
      const bLat = b.place?.lat ?? -Infinity;
      
      // From north to south = from larger to smaller lat values (descending)
      // From south to north = from smaller to larger lat values (ascending)
      if (this.sortDirection === 'northToSouth') {
        return bLat - aLat; // Descending order (north to south)
      } else {
        return aLat - bLat; // Ascending order (south to north)
      }
    });
  }

  toggleSortDirection() {
    this.sortDirection = this.sortDirection === 'northToSouth' ? 'southToNorth' : 'northToSouth';
    // Re-sort clusters
    this.clusters = this.sortClustersByLon(this.clusters);
    // Re-apply filters to maintain filtered list
    this.filterClusters();
  }

  private updateBranchesMapLocationsList(clusters: any[]) {
    this.branchesMapLocationsList = clusters.map(cluster => {
      const obj: any = {
        name: cluster.serial_name || '',
        location: {
          lon: cluster.place.lon,
          lat: cluster.place.lat
        },
        top: cluster.place.top
      };
      if (cluster.time && cluster.time !== 0) {
        obj.time = cluster.time;
      }
      return obj;
    });
  }

  private handleBranchFromRoute(branchName: string) {
    if (this.clusters.length === 0) {
      const clustersSubscription = this.clustersService
        .getClustersWithAvailableSystems()
        .pipe(
          retry(3),
          catchError((error) => {
            console.error('Failed to fetch clusters:', error);
            const current = this.router.url.split('?')[0];
            if (current !== '/' && current !== '') {
              this.router.navigate(['/']);
            }
            return throwError(error);
          })
        )
        .subscribe(({ clusters, avalblesystems }) => {
          if (avalblesystems && typeof avalblesystems === 'object') {
            this.avalbleSystems = {
              '3DPrint': avalblesystems['3DPrint'] ?? this.avalbleSystems['3DPrint'],
              phPrint: avalblesystems.phPrint ?? this.avalbleSystems.phPrint,
            };
          }
          this.clusters = this.sortClustersByLon(clusters);
          this.filteredClusters = this.clusters;
          this.isLoading = false;
          this.findAndSetClusterByBranch(branchName);
          clustersSubscription.unsubscribe();
        });
    } else {
      this.findAndSetClusterByBranch(branchName);
    }
  }

  private findAndSetClusterByBranch(branchName: string) {
    for (let cluster of this.clusters) {
      const foundInPlotter = cluster.plotter?.some(
        (printer: any) => printer.serial_name === branchName
      );
      const foundInExpress = cluster.express?.some(
        (printer: any) => printer.serial_name === branchName
      );

      if (foundInPlotter || foundInExpress) {
        this.branchName = branchName;
        this.clusterName = cluster.serial_name;
        this.dataSharingService.setBranch(branchName);
        this.dataSharingService.setCluster(cluster.serial_name);
        this.updateClusterName();
        this.updatecontinueToClusterText();
        this.isSystemSet = true;
        return;
      }
    }
    const current = this.router.url.split('?')[0];
    if (current !== '/' && current !== '') {
      this.router.navigate(['/']);
    }
  }

  ngAfterViewInit(): void {
    if (this.scrollContainer) {
      this.scrollListener = this.renderer.listen(
        this.scrollContainer.nativeElement,
        'scroll',
        () => {
          this.updateScrollPosition();
        }
      );
    }

    // GOOGLE MAPS
    setTimeout(() => {
      const mapDiv = document.getElementById('map');
      if (!mapDiv) return;

      this.map = new maplibregl.Map({
        container: mapDiv,
        style: getMapTilerStyleUrl(),
        center: [34.94, 32.03],
        zoom: 8.6,
        attributionControl: false,
      });

      this.map.on('load', () => {
        this.map.resize();
        this.zoom = this.map.getZoom();
        // Resize again after layout has settled so container width is correct
        setTimeout(() => this.map?.resize(), 100);
        requestAnimationFrame(() => this.map?.resize());
        const transFormedbranchesMapLocationsList =
          this.branchesMapLocationsList.sort((a, b) => b.top - a.top);
        transFormedbranchesMapLocationsList.forEach((branch) => {
          const location = branch.location;
          const name = branch.name;
          const el = document.createElement('div');
          el.className = 'custom-marker';
          el.innerHTML = `<div style="display: flex; flex-direction: column; align-items: center; cursor: pointer">
               <div class="marker-label" style="background:rgba(255, 255, 255, 0.85); font-size:12px; color:#26a69a; border-radius: 13px; padding: 0 6px; font-size: 13px; margin-bottom: 2px; cursor: pointer;">
                 ${this.translateService.instant(
            'choose-branch.naming.' + name
          )}
               </div>
             </div>`;
          const marker = new maplibregl.Marker({ element: el })
            .setLngLat([location.lon, location.lat])
            .addTo(this.map);
          this.markerElements.push(el);
          el.addEventListener('click', () => {
            this.clusterName = branch.name;
            this.updatecontinueToClusterText();
            this.onSetCluster();
          });
        });
        this.updateZoom();
        this.map.on('zoom', () => {
          this.updateZoom();
        });
      });

      this.map.zoomTo(this.zoom, { duration: 1000 });
      if (this.map) this.map.resize();
    }, 0);
    setTimeout(() => {
      this.updateMarkerLabels();
    }, 0);
    this.translateService.onLangChange.subscribe(() => {
      setTimeout(() => {
        this.updateMarkerLabels();
      }, 0);
    });
  }

  updateZoom() {
    const zoom = this.map.getZoom();
    this.zoom = zoom;
    const markers = document.querySelectorAll('.custom-marker');
    this.branchesMapLocationsList.forEach((branch, i) => {
      const marker = markers[i] as HTMLElement;
      if (marker) {
        const timming = branch.time ? branch.time : 10;
        const padding =
          zoom > timming + 6
            ? 0
            : zoom < timming
              ? branch.top
              : branch.top - (zoom - timming) * branch.top;
        marker.style.paddingTop = `${padding}px`;
      }
    });
  }

  updateMarkerLabels() {
    this.branchesMapLocationsList.forEach((branch, i) => {
      const name = branch.name;
      const el = this.markerElements[i];
      if (el) {
        const label = el.querySelector('.marker-label');
        if (label) {
          label.innerHTML = this.translateService.instant(
            'choose-branch.naming.' + name
          );
        }
      }
    });
  }

  updateClusterName() {
    if (this.branchName !== '') {
      for (let cl of this.clusters) {
        if (
          cl.plotter?.some(
            (printer) => printer.serial_name === this.branchName
          ) ||
          cl.express?.some((printer) => printer.serial_name === this.branchName)
        ) {
          this.clusterName = cl.serial_name;
          this.dataSharingService.setCluster(this.clusterName);
          if (this.clusterName && this.clusterName !== '') {
            setTimeout(() => {
              const clusterIndex = this.clusters.findIndex(
                (cluster) => cluster.serial_name === this.clusterName
              );
              if (clusterIndex !== -1) {
                const targetElement =
                  this.branchElements.toArray()[clusterIndex];
                if (targetElement && this.scrollContainer) {
                  const container = this.scrollContainer.nativeElement;
                  const element = targetElement.nativeElement;
                  const containerTop = container.scrollTop;
                  const containerBottom = containerTop + container.clientHeight;
                  const elemTop = element.offsetTop;
                  const elemBottom = elemTop + element.offsetHeight;

                  const isVisible =
                    elemTop >= containerTop && elemBottom <= containerBottom;

                  if (!isVisible) {
                    // גלול עם מרווח 20 פיקסלים מהקצה
                    container.scrollTo({
                      top:
                        elemTop -
                        container.clientHeight +
                        element.offsetHeight +
                        93,
                      behavior: 'smooth',
                    });
                  }
                }
              }
            }, 100);
          }
          break;
        } else {
          this.clusterName = '';
        }
      }
    }

    for (let cl of this.clusters) {
      const translatedName = this.translateService.instant(
        'choose-branch.naming.' + cl.serial_name
      );
      cl.translatedName = translatedName;
    }

    // setTimeout(() => { this.updateMap(); }, 0);
    // this.resizeObserver = this.renderer.listen('window', 'resize', (event) => {
    //   setTimeout(() => { this.updateMap(); }, 0);
    // });
    this.updatecontinueToClusterText();
    setTimeout(() => {
      if (this.clusterName !== '') {
        this.isSystemSet = true;
      } else {
        this.isSystemSet = false;
      }
    }, 120);
  }

  ngOnDestroy() {
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
    if (this.branchSub) {
      this.branchSub.unsubscribe();
    }
    if (this.clusterSub) {
      this.clusterSub.unsubscribe();
    }
    if (this.scrollListener) {
      this.scrollListener();
    }
    if (this.map) {
      this.map.remove();
    }
  }

  onHoverPrintingService(value: string) {
    this.hoveredPrintingService = value;
  }

  onChooseCluster(value: string) {
    if (value && value !== '') {
      this.clusterName = value;
      this.updatecontinueToClusterText();
      this.onSetCluster();
    }
  }

  onSetCluster() {
    if (this.clusterName !== '') {
      this.dataSharingService.setCluster(this.clusterName);
      this.router.navigate(['/branch']);
    }
  }

  updatecontinueToClusterText() {
    this.continueToClusterText =
      this.translateService.instant('choose-system.continue-to') +
      this.translateService.instant('choose-branch.naming.' + this.clusterName);
  }

  updatebyPrinterNumberExplanation() {
    this.byPrinterNumberExplanation = this.translateService.instant(
      'choose-system.by-printer-number-explanation'
    );
  }

  goToHomePage() {
    this.router.navigate(['/home']);
  }

  /** שני כרטיסי הכניסה ל־PH בבחירת סניף – SU וב־bmph רואים תמיד גם כשלא מוגדר avalbleSystems */
  getPhProductEntryModes(): string[] {
    return ['3dprint', 'phprint'];
  }

  /** האם להציג כרטיס PH ספציפי (הדפסת תלת מימד / הדפסה במשלוח) */
  canShowPhEntry(kind: string): boolean {
    if (this.isSu() || this.isBmph()) return true;
    if (kind === '3dprint') return !!this.avalbleSystems?.['3DPrint'];
    if (kind === 'phprint') return !!this.avalbleSystems?.phPrint;
    return false;
  }

  getPhEntryPromoIconSrc(kind: string): string {
    return kind === '3dprint'
      ? 'assets/images/3dprint-icon.svg'
      : 'assets/images/phprint-icon.svg';
  }

  isPhCardMoreInfo(kind: string): boolean {
    return !!this.phMoreInfoByKind[kind];
  }

  goToProducts(phKind?: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    if (phKind === 'phprint') {
      this.router.navigate(['/phproduct']);
    } else {
      this.router.navigate(['/3dproduct']);
    }
  }

  openPrinterNumnerDialod() {
    this.dialogService.onOpenPrinterNumberDialog();
  }

  isSu() {
    if (localStorage.getItem('roles')?.includes('su')) {
      return true;
    }
    return false;
  }

  /** מנהלי מערך דפוס (bmph) – כמו SU לצורך כרטיסי הכניסה ל־PH בעמוד הבית */
  isBmph(): boolean {
    return !!localStorage.getItem('roles')?.includes('bmph');
  }

  // updateMap() {
  //   const mapContainer = document.getElementById('map-branch-container');
  //   if (mapContainer) {
  //     this.mapContainerWidth = mapContainer.offsetWidth;
  //     this.mapContainerHeight = mapContainer.offsetHeight;
  //   }
  //   this.clusters.forEach((cluster, index) => {
  //     const location = this.branchesMapLocationsList.find(item => item.name === cluster.serial_name)?.location;
  //     if (location) {
  //       const branchElement = this.mapBranchItems.toArray()[index];
  //       // Check if branchElement is defined
  //       if (branchElement && branchElement.nativeElement) {
  //         // Set the 'left' and 'top' CSS properties of the branch element
  //         this.renderer.setStyle(branchElement.nativeElement, 'left', `${location.x * this.mapContainerWidth}px`);
  //         this.renderer.setStyle(branchElement.nativeElement, 'top', `${location.y * this.mapContainerHeight}px`);
  //       } else {
  //         // console.log('branchElement is not found');
  //       }
  //     } else {
  //       // console.log('Location is not found for branch:', cluster.serial_name);
  //     }
  //   });
  // }

  // search

  private setSearchPlaceholder() {
    this.translateService
      .get('choose-branch.search-placeholder')
      .subscribe((res: string) => {
        this.searchPlaceholder = res;
      });
  }

  filterClusters(): void {
    this.filteredClusters = [];
    this.filteredClustersIndexes = [];
    for (let cl of this.clusters) {
      // בדיקת סוגי מדפסות
      const hasPlotter = cl.plotter && cl.plotter.length > 0;
      const hasExpress =
        cl.express &&
        cl.express.length > 0 &&
        cl.express.some((e) => !e.isPicsPrinter);
      const hasPics =
        cl.express &&
        cl.express.length > 0 &&
        cl.express.some((e) => e.isPicsPrinter);

      // סינון לפי סוג מדפסת
      let matchesType = false;
      if (this.printerTypeFilter === 'all') {
        matchesType = true;
      } else if (this.printerTypeFilter === 'plotter' && hasPlotter) {
        matchesType = true;
      } else if (this.printerTypeFilter === 'express' && hasExpress) {
        matchesType = true;
      } else if (this.printerTypeFilter === 'pics' && hasPics) {
        matchesType = true;
      }

      // סינון לפי טקסט
      const matchesText =
        !this.searchText ||
        cl.translatedName.toLowerCase().includes(this.searchText.toLowerCase());

      if (matchesType && matchesText) {
        this.filteredClusters.push(cl);
        this.filteredClustersIndexes.push(true);
      } else {
        this.filteredClustersIndexes.push(false);
      }
    }
    if (this.clusters.length > 0 && this.filteredClusters.length === 0) {
      this.filteredClusters = this.clusters;
      this.isfilteredClustersEmpty = true;
      this.filteredClustersIndexes = [];
    } else {
      this.isfilteredClustersEmpty = false;
    }
  }

  setPrinterTypeFilter(type: 'all' | 'plotter' | 'express' | 'pics') {
    this.printerTypeFilter = type;
    this.filterClusters();
  }

  getClusterPrintersText(cluster: any): string {
    const printers: string[] = [];
    
    // בדיקת סוגי מדפסות
    const hasPlotter = cluster.plotter && cluster.plotter.length > 0;
    const hasExpress =
      cluster.express &&
      cluster.express.length > 0 &&
      cluster.express.some((e: any) => !e.isPicsPrinter);
    const hasPics =
      cluster.express &&
      cluster.express.length > 0 &&
      cluster.express.some((e: any) => e.isPicsPrinter);

    // הוספת המדפסות לפי הסדר: plotter, express, pics
    if (hasPlotter) {
      printers.push(this.translateService.instant('choose-branch.printer.plotter'));
    }
    if (hasExpress) {
      printers.push(this.translateService.instant('choose-branch.printer.express'));
    }
    if (hasPics) {
      printers.push(this.translateService.instant('choose-branch.printer.pics'));
    }

    return printers.join(', ');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.isScreenWide = window.innerWidth > 768;
    this.isSmUp = window.innerWidth >= 576;
    if (this.isScreenWide) {
      this.isMapMode = false;
    }
  }

  updateScrollPosition(): void {
    if (this.scrollContainer) {
      this.scrollPosition = this.scrollContainer.nativeElement.scrollTop;
    }
  }

  // map mode mobile

  /** Call after switching to map mode so the map container has real dimensions and the map redraws correctly */
  resizeMapWhenVisible(): void {
    setTimeout(() => {
      if (this.map) this.map.resize();
    }, 50);
    setTimeout(() => {
      if (this.map) this.map.resize();
    }, 200);
  }

  goToMapMode() {
    this.isMapMode = true;
    this.resizeMapWhenVisible();
  }

  goToListMode() {
    this.isMapMode = false;
  }

  /** טקסט פתיחה בכרטיס PH — מקוצר כשהכרטיס סגור */
  private readonly phCardIntroPreviewMaxCharsDesktop = 122;
  private readonly phCardIntroPreviewMaxCharsMobile = 100;
  private readonly phCardIntroMobileFirstLineMaxChars = 35;
  disableRippleOnce = false;

  private getPhCardIntroMaxChars(): number {
    return this.isSmUp
      ? this.phCardIntroPreviewMaxCharsDesktop
      : this.phCardIntroPreviewMaxCharsMobile;
  }

  /** מפתח בסיס לתרגומי כרטיס PH (3dprint | phprint) */
  phCardI18nBase(kind: string): string {
    return `choose-branch.ph-card.${kind}`;
  }

  phCardSectionKey(kind: string, section: 1 | 2, part: 'title' | 'text'): string {
    if (part === 'title') {
      return `choose-branch.ph-card.section${section}-title`;
    }
    return `${this.phCardI18nBase(kind)}.section${section}-text`;
  }

  getPhCardIntroForKind(kind: string): string {
    const full = this.translateService.instant(`${this.phCardI18nBase(kind)}.intro`);
    if (this.isPhCardMoreInfo(kind) || !full) {
      return full;
    }
    const max = this.getPhCardIntroMaxChars();
    if (full.length <= max) {
      return full;
    }
    return full.slice(0, max).trimEnd() + '...';
  }

  getPhCardIntroLinesForKind(kind: string): string[] {
    const text = this.getPhCardIntroForKind(kind);
    if (this.isSmUp || !text || text.length <= this.phCardIntroMobileFirstLineMaxChars) {
      return [text];
    }
    const max = this.phCardIntroMobileFirstLineMaxChars;
    const breakIndexBeforeMax = text.lastIndexOf(' ', max);
    const breakIndexAfterMax = text.indexOf(' ', max);
    const breakIndex = breakIndexBeforeMax > 0 ? breakIndexBeforeMax : breakIndexAfterMax;
    if (breakIndex <= 0) {
      return [text];
    }
    return [
      text.slice(0, breakIndex).trimEnd(),
      text.slice(breakIndex + 1).trimStart(),
    ];
  }

  getPhCardSystemKey(kind: string): ChatProductSystemKey {
    return kind === '3dprint' ? '3DPrint' : 'phPrint';
  }

  openPhSystemChat(kind: string, event: MouseEvent): void {
    event.stopPropagation();
    const uid = this.authService.getUserId() || localStorage.getItem('userId');
    if (!uid) {
      this.dialogService.onOpenLoginDialog('', '', this.getPhCardSystemKey(kind));
      return;
    }
    void this.router.navigate(['/chat', 'user', uid, 'system', this.getPhCardSystemKey(kind)]);
  }

  onMoreInfoPhClick(kind: string, event: MouseEvent) {
    event.stopPropagation();
    this.phMoreInfoByKind[kind] = !this.phMoreInfoByKind[kind];
    this.disableRippleOnce = true;
    setTimeout(() => this.disableRippleOnce = false, 0);
  }
  // ==================
}
